const PACKLIST_STATUS_MODIFIER = {
  PACKLIST_STATUS_UNSPECIFIED: 'unspecified',
  PACKLIST_STATUS_PENDING: 'pending',
  PACKLIST_STATUS_RECEIVED: 'received',
  PACKLIST_STATUS_NOT_RECEIVED: 'not_received',
  PACKLIST_STATUS_PICKING: 'picking',
  PACKLIST_STATUS_PACKING: 'packing',
  PACKLIST_STATUS_PACKED: 'packed',
  PACKLIST_STATUS_CANCELLED: 'cancelled',
}

/**
 * CSS modifier for packlist status colouring.
 * Mirrors the picking-order palette: pending=orange, in-progress=blue,
 * packed/received=green, cancelled/not-received=red.
 */
export const getPacklistStatusClassName = (status) => {
  const modifier =
    PACKLIST_STATUS_MODIFIER[status] ||
    String(status || 'unspecified')
      .toLowerCase()
      .replace(/^packlist_status_/, '')
      .replace(/-/g, '_')
  return `packlist-status packlist-status--${modifier}`
}
